export const dateTimeFormats = {
  1: "MMM D, YYYY",
  2: "h:mma",
  3: "YYYY-MM-DD",
  4: "DD MMM YYYY",
  5: "DD-MM-YYYY", 
};

export const formatTypes = {
  centered: "MMM D, YYYY · h:mma",
  timestamp: "MMM D, YYYY [at] h:mm A",
  dateOnly: "MMM D, YYYY",
  timeOnly: "h:mm A",
  iso: "YYYY-MM-DDTHH:mm:ss.SSS[Z]",
  monthDay: "MMM D",
  time24Hour: "HH:mm",
  time12Hour: "h:mma",
  signalDate: "DD-MM-YYYY",
  formDateTime: "hh:mmA, MM/DD/YYYY",
  formDate: "MM/DD/YYYY",
  tableDateTime: "D MMM YYYY, h:mmA",
};

export const timeUnits = [
  { value: "sec", label: "seconds" },
  { value: "min", label: "minutes" },
  { value: "hour", label: "hours" },
];

export const monthNames = [
  "January", "February", "March", "April", "May", "June",
  "July", "August", "September", "October", "November", "December"
];